import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import { latestHeurigenUpdateDb, fetchHeurigen } from '../util/http-heurigen';
import { niceDate } from '../util/date';

import "./Home.css"

function HeurigenList (props){
    const gridRef = useRef();
    const [gridApi, setGridApi] = useState(null);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [heurigen, setHeurigen] = useState([]);    

    const onGridReady = (params) => {
        setGridApi(params.api);
      };

    async function loadFromDb() {        
        let _heurigen = await fetchHeurigen();        
        if(_heurigen.status != 200) {
            console.log('heurigen-context ERROR error fetching heurigen: ', _heurigen.status);            
        } else {
            // console.log('heurigen-context fetched heurigen; sample: ', _heurigen.data[0]);
            console.log('heurigen-context: Fetched heurigen', _heurigen.data);
            setHeurigen(_heurigen.data);
            setDataLoaded(true);
        }        
    }

    const ts2Date = (params) => {      
        return niceDate(new Date(params.value*1000), 2);        
      };


    const rowDoubleClicked = (params) => {  
//    let target = '/doc2graph_kd?id=' + encodeURIComponent(params.data.publication);
  //        if (params.data.publication) {
    //        console.log('target', target)
      //      return(<Redirect to={target}/>)
        //  } else {          
//           } 
  }

   

  const linkHeuriger = (params) => {
    // let target = '/heuriger?id=' + encodeURIComponent(params.value);    


          if (params.value) {
            return (
              <Link to={'heuriger'} state={{id: params.value, currentAccount: props.currentAccount}}>
                <button type="button" className="btn btn-primary btn-sm" >Öffnen</button>
              </Link>
              
            );
          } else {
            return <Fragment>-</Fragment>
          } 
  };

    const [columnDefs] = useState([
        { field: "id", flex: 1, cellRenderer: linkHeuriger },
        { field: "id", headerName: 'Id', flex: 1 },
        { field: "name", headerName: 'Name', flex: 5 },
        { field: "hide", headerName: 'Versteckt', flex: 5, cellRenderer: (params) => { return params.data?.hide ? 'Ja' : 'Nein'} },
        { field: "_ts", headerName: 'Letzte Änderung', flex: 1, cellRenderer: ts2Date}
    ]);
    
    useEffect(() => {
      console.log('rendering', props.currentAccount);
        loadFromDb();

        if(gridApi && !dataLoaded) {
            gridApi.showLoadingOverlay();
          }
          if(gridApi && dataLoaded && heurigen?.length > 0) {
            gridApi.hideOverlay();
          }
    }, []); 

    return (
        // <ul className="list-group list-group-flush">
           //  <li className="list-group-item">bla1-n</li>
            // <li className="list-group-item">bla2-n</li>                        
        // </ul>
        <div>  
            <div className="ag-theme-alpine" >
                <AgGridReact
                    ref={gridRef}
                    defaultColDef={{sortable: true, filter: true, resizable: true }}
                    rowData={heurigen}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onRowDoubleClicked={rowDoubleClicked}
                    localeText={{noRowsToShow: 'Keine Daten', loadingOoo: 'Daten werden geladen ...'}}            
                    domLayout='autoHeight'>
                </AgGridReact>
            </div>
        </div>                
    )
}

export default HeurigenList;